import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {ABACPolicy, ABACPolicyEntity} from "../../../model/abac-policy";

export interface ABACPolicySelectorProps {

}

export const abacPoliciesSelector = () => createSelector(
  [getUseQueryResultData<ABACPolicy[]>],
  (data) => {
    return selectABACPoliciesAndTransform(
      data ?? [], {}
    );
  }
);

export const abacPolicySelector = () => createSelector(
  [getUseQueryResultData<ABACPolicy>],
  (data) => {
    return data ? transformABACPolicy(data) : undefined;
  }
);

export const selectABACPolicies = (values?: ABACPolicy[], selector?: ABACPolicySelectorProps): ABACPolicy[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformABACPolicy = (value: ABACPolicy): ABACPolicyEntity => {
  return ABACPolicyEntity.from(value)
}

export const selectABACPoliciesAndTransform = (values?: ABACPolicy[], selector?: ABACPolicySelectorProps): ABACPolicyEntity[] => {
  const selected = selectABACPolicies(values, selector);
  return selected.map(transformABACPolicy);
};
